import { render, staticRenderFns } from "./ArchivedLocations.vue?vue&type=template&id=2a24527b&"
import script from "./ArchivedLocations.vue?vue&type=script&lang=js&"
export * from "./ArchivedLocations.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedLocations.vue?vue&type=style&index=0&id=2a24527b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports